import React from 'react';
import { Leaf } from 'lucide-react';
export function RSE() {
  return <section id="rse" className="py-24 bg-gradient-to-b from-white to-gray-50 relative" data-id="element-287">
      <div className="w-full max-w-[1200px] mx-auto px-6" data-id="element-288">
        <div className="bg-gradient-to-br from-primary-light/40 to-primary-light/20 rounded-3xl p-8 md:p-16 flex flex-col md:flex-row items-center gap-12 border border-primary/20 shadow-lg" data-id="element-289">
          <div className="md:w-1/3 flex justify-center" data-id="element-290">
            <div className="relative" data-id="element-291">
              <div className="absolute inset-0 bg-primary blur-2xl opacity-20 rounded-full" data-id="element-292"></div>
              <div className="relative w-40 h-40 bg-white rounded-full flex items-center justify-center shadow-xl text-primary" data-id="element-293">
                <Leaf size={80} strokeWidth={1.5} data-id="element-294" />
              </div>
            </div>
          </div>

          <div className="md:w-2/3 text-center md:text-left" data-id="element-295">
            <h2 className="text-3xl md:text-4xl font-bold text-secondary-dark mb-6" data-id="element-296">
              Notre engagement <span className="text-primary" data-id="element-297">RSE</span>
            </h2>

            <div className="space-y-4 text-lg text-gray-600 leading-relaxed" data-id="element-298">
              <p data-id="element-299">
                Chez 1001 Palettes, nous croyons en une logistique plus durable.
                Notre modèle de courtage favorise les{' '}
                <strong className="text-secondary-dark font-semibold" data-id="element-300">
                  circuits courts
                </strong>{' '}
                en optimisant les flux existants.
              </p>
              <p data-id="element-301">
                En réduisant les transports à vide et en favorisant le réemploi,
                nous contribuons activement à l'économie circulaire. Chaque
                palette réutilisée est une victoire contre le gaspillage.
              </p>
            </div>

            <div className="mt-8 flex flex-wrap gap-4 justify-center md:justify-start" data-id="element-302">
              <span className="px-4 py-2 bg-white rounded-lg border border-primary/20 text-primary-dark font-medium text-sm shadow-sm" data-id="element-303">
                🌱 Économie circulaire
              </span>
              <span className="px-4 py-2 bg-white rounded-lg border border-primary/20 text-primary-dark font-medium text-sm shadow-sm" data-id="element-304">
                🚛 Réduction CO2
              </span>
              <span className="px-4 py-2 bg-white rounded-lg border border-primary/20 text-primary-dark font-medium text-sm shadow-sm" data-id="element-305">
                ♻️ Zéro gaspillage
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}